import { Component, Input, OnChanges } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-partner",
	templateUrl: "./manage-partner.component.html",
	styleUrls: ["./manage-partner.component.scss"]
})
export class ManagePartnerComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	public assetPartners: APIResults.Organization[];
	public assetPotentialPartners: APIResults.Organization[];
	public addPartnerOrg: APIResults.Organization;

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await this.RefreshData();
	}

	async RefreshData(): Promise<void> {
		this.assetPartners = await this.api.GetAssetPartners(this.asset.asset_id);
		const organizations = await this.api.GetOrganizations();
		this.assetPotentialPartners = organizations.filter(item => item.organization_id !== this.asset.organization_id && !this.assetPartners.some(partner => partner.organization_id === item.organization_id));
	}

	public async AddPartner() {
		await this.api.AddAssetPartner(this.asset.asset_id, this.addPartnerOrg.organization_id);
		await this.RefreshData();
	}
	public async DeletePartner(organization_id: number) {
		await this.api.DeleteAssetPartner(this.asset.asset_id, organization_id);
		await this.RefreshData();
	}
}
